import { alpha, lighten, darken } from '@mui/material/styles';

export function buildHeaderPalette({ mode, brandMain }) {
  const background = brandMain;
  const text = '#ffffff';

  return {
    background,
    text,
    border: mode === 'dark' ? alpha('#ffffff', 0.16) : alpha('#000000', 0.12),
    hover: mode === 'dark' ? lighten(brandMain, 0.1) : darken(brandMain, 0.08),
    shadow: mode === 'dark'
      ? '0 18px 35px rgba(0,0,0,0.65)'
      : '0 10px 25px rgba(128,0,0,0.35)',
    selectBg: mode === 'dark' ? alpha('#ffffff', 0.12) : '#ffffff',
    selectText: mode === 'dark' ? '#f5f5f5' : '#2f2f2f',
    selectIcon: text,
    tabInactive: alpha('#ffffff', 0.75),
    tabActive: '#ffffff',
    indicator: '#ffffff',
  };
}
